import { connect } from 'react-redux';
import {
    showOrgSurveyLoader,
    fetchOrgSurveysEngagementReportChartData
} from 'actions/OrgSurvey';
import Component from './Component';


export const mapStateToProps = ({ orgSurveys }) => {
    const {
        orgSurveyCompareList,
        orgSurveyCompareDistributionsChartData,
        orgSurveyCompareTopResultsChartData,
        orgSurveyCompareBottomResultsChartData,
    } = orgSurveys;
    return {
        orgSurveyCompareList,
        orgSurveyCompareDistributionsChartData,
        orgSurveyCompareTopResultsChartData,
        orgSurveyCompareBottomResultsChartData,
    };
};
export default connect(mapStateToProps, {
    showOrgSurveyLoader,
    fetchOrgSurveysEngagementReportChartData
})(Component);


// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Container.js